// extracted by mini-css-extract-plugin
export default {"alignRightCell":"styles_alignRightCell__bJrrP","row":"styles_row__OEctD"};